<template>
        <div>
            <div class="c"></div>
            <div id="bd">
                <div class="" id="whous">
                    <img src="../assets/Images/zhjc_02.png">
                    <div class="tit-i" id="sjck">
                        <h3>数据仓库解决方案</h3>
                        <h5><span>DW </span>SOLUTION</h5>
                    </div>
                    <div class="zh-linebox" >
                        <div class="wp">
                            <img src="../assets/Images/zhjc_05.png" style="width:100%;display:block">
                        </div>
                    </div>
                    <div class="zh-linebox" style="position:relative;padding-top:60px;overflow:hidden" id="ldjsc">
                        <div style="position: absolute;text-align:center;width:100%;">
                            <h3 style="margin:40px 0">领导驾驶舱</h3>
                        </div>
                        <img src="../assets/Images/zhjc_08.png" style="width:100%;">
                    </div>
                    <!--产品-->
                    <div class="wp">
                        <div class="tit-i">
                            <h3>产品</h3>
                            <h5><span>PRODUCTS</span></h5>
                        </div>
                        <ul class="product">
                            <li>制式统计</li>
                            <li>领导驾驶舱</li>
                            <li>决策分析</li>
                            <li>统计查询</li>

                        </ul>
                    </div>
                    <div class="c h50"></div>
                     <div class="h50"></div>
                </div>
            </div>
            
        </div>
</template>
<script>
export default {
    mounted(){
        setTimeout(() => {
                // console.log($.isEmptyObject(this.$route.params))
                if(!$.isEmptyObject(this.$route.params)){
                    document.querySelector("#"+this.$route.params.id).scrollIntoView(true);  
                }
        }, 100);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/zhjc.vue